import { Route, Routes } from 'react-router-dom';

import { CompletePage, ParkingPage } from './ui';

export const Parking = () => {
  return (
    <Routes>
      <Route path='/' element={<ParkingPage />} />
      <Route path='/complete' element={<CompletePage />} />
    </Routes>
  );
};
